export default __webpack_public_path__ + "static/media/NUG_Ideal_Articlepage.b99544f5.jpg";